import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const REGEX = {
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[\x21-\x7E]{8,}$/,
  PHONE_NUMBER: /^((?!(0))[0-9]{7,})$/,
  URL_PHONE_NUMBER: /^((?!(0))[0-9]{7,16})$/,
  TWO_NUMERIC_DIGITS: /^(\d+)?([*]?\d{0,2})?$/,
  NUMBER_WITH_DOT: /(?: |^)\d*\.?\d+(?: |$)/,
  TWO_CHARACTERS: /^(?=.{2,})/,
  EIGHT_CHARACTERS: /^(?=.{8,})/,
  TEN_CHARACTERS: /^(?=.{10,})/,
  ONE_UPPER_CASE: /(?=.*[A-Z])/,
  ONE_SYMBOL: /(?=.*[!@#$%])/,
  LOGIN_MOBILE: /^[1-9][0-9]*$/,
  EMAIL: /^[A-Z0-9_-]+([\.+][A-Z0-9_-]+)*@[A-Z0-9-]+(\.[a-zA-Z]{2,4})+$/i,
  USERNAME: /^(?![0-9]+$)(?![.])(?!.*[.]$).*[A-Za-z0-9_.]$/,
  NUMBER: /^[0-9]+$/,
  NUMBER_START_WITH_ONE: /^[1-9]+$/,
  VERIFY_CODE: /^([0-9]{6})$/,
  // tslint:disable-next-line:max-line-length
  NUMBER_WITH_DECIMAL:
    /^\$?([1-9]{1}[0-9]{0,2}(\,[0-9]{3})*(\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\.[0-9]{0,2})?|0(\.[0-9]{0,2})?|(\.[0-9]{1,2})?)$/,
  CHARACTERS: /^[a-zA-Z' ]*$/i,
  CHARACTERS_WITH_DOT: /^[a-zA-Z]{1}[a-zA-Z/. /s]*$/i,
  // tslint:disable-next-line:max-line-length
  WEBSITE_URL_WITH_HTTP: /^(https?:\/\/)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,5}(:\d{1,5})?(\/.*)?$/,
  WEBSITE_URL:
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|Http:\/\/www\.|Https:\/\/www\.|Http:\/\/|Https:\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  WEBSITE_URL_HTTP:
    /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?\/$/,
  END_SPACE: /\s$/,
  // tslint:disable-next-line: max-line-length
  FACEBOOK:
    /(?:https(?:s)?:\/\/)?(?:www\.)?(?:facebook\.com|fb\.com)\/([a-zA-Z0-9_.]+)(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile\.php\?id=(?=\d.*))?([\w\-]*)?/,
  LINKEDIN: /^https:\/\/[a-z]{2,3}\.linkedin\.com\/.*$/,
  TWITTER: /(https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/([a-zA-Z0-9_]+)/,
  INSTAGRAM: /(https?:\/\/)?www\.instagram\.com\/([a-zA-Z0-9_.]+)/,
  TIKTOK: /(https?:\/\/)?www\.tiktok\.com\/(?:@)?([a-zA-Z0-9_.]+)/,
  YOUTUBE_USERNAME: /^[a-zA-Z0-9_-]{3,20}$/,
  SPOTIFY_USERNAME: /^(?:(?:user|artist|playlist|show|episode)\/)?[a-zA-Z0-9_]{3,30}\/?$/,
  FACEBOOK_USERNAME: /^[a-zA-Z0-9\.]{5,50}$/,
  TWITTER_USERNAME: /^@?([a-zA-Z0-9_]{1,15})$/,
  INSTAGRAM_USERNAME: /^[a-zA-Z0-9_.]{1,30}\/?$/,
  TIKTOK_USERNAME: /^@?([a-zA-Z0-9_.]{2,24})$/,
  HIRING_TEAM: /^[a-zA-Z !@#\$%\^\&*\,)\(+=._-]{2,}$/,
  N_W_S_AT_B: /^(?![0-9 0-9]+$)[a-zA-Z0-9][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/i, // no white space at beginning
  NAME_WITHOUT_WHITE_SPACE: /^[a-zA-Z0-9][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/i, // no white space at beginning
  MONETIZE_DESCRIPTION: /^[^\s][a-zA-Z0-9\s\[\]\{\}\(\)!@#$%^&*|\\?\/\.,+\-=~_'`-]*$/i,
  ONLY_NON_WHITESPACE: /\S{1,}/,
  FIRST_OR_LAST_NAME: /^(?=.{1,50}$)[a-z]+(?:['_.\s][a-z]+)*$/i,
  POSTAL_CODE: /^(?!(?:.*-){2})(?!(?:.* ){2})[A-Za-z0-9 -]{3,10}$/,
  // ALLOW_TO_GET_ALL_URL: /((?:(http|https|Http|Https|rtsp|Rtsp|www):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?/gi,
  // ALLOW_TO_GET_ALL_URL: /(^((http|https)://)[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$/
  ALLOW_TO_GET_ALL_URL:
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
  VALID_URL: /\b((https?:\/\/|www\.)[^\s<>"']+)|(?!www\.)[a-zA-Z0-9-]+\.[a-zA-Z]{2,}([\/?#][^\s<>"']*)?/g,
  ALL_HASHTAG_LIST: /(\s|^)\#\w\w+\b/gm,
  usereRegex: '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{1,2}$',
  CHARACTERS_NOSPACE_ON_FIRSTPOS: /^(?!\s)[a-zA-Z ]*$/i,
  CHARACTERS_NOSPACE_ON_FIRSTPOS_FULLSTOP: /^(?!\s)[a-zA-Z. ]*$/i,
  TIME_TWELVE_HOUR_FORMAT: /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/i,
  TIME_TWENTY_HOUR_FORMAT: /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/,
  WHITE_SPACE: /\s/g,
  HAVE_WHITE_SPACE: /^\s+$/,
  SPECIAL_CHAR_REPLACE: /[&\/\\#,+()$~%'":*?<>{}\s]/g,
  START_WITH_ZERO: /^0+/,
  PREFIX_POST_IMAGE: /^post_\d+_/,
  PREFIX_IMAGE_URL: /post_\d+_(.+)/,
  ANCHOR_LINKS: /((https?:\/\/[^\s]+))/g,
  MIME_TYPE: /\.\w+$/,
  ALPHA_NUMERIC_WITH_SPECIAL_CHARS:
    '^[a-zA-Z0-9 !@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]*$',
  WEBSITE_URL_PATTERN:
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
  AMOUNT_REGEX: /^(?!0$)\d+(\.\d+)?$/,
  DECIMAL_TWO_PLACES: /^\d*\.?\d{0,2}$/,
  DISPLAYED_CREATOR_NAME: /^[a-zA-Z0-9._]*$/,
  PUBLICLY_DISPLAYED_NAME_SPECIAL_CHARS: /[`!@#$%^&*()+\=[\]{};':"\\|,<>\/?~]/,
  ONLY_DIGITS: /^[0-9]$/,
  NON_NUMERIC: /\D/g,
  ONLY_PERCENTAGE: /^\d+(\.\d+)?$/,
  IMAGE_UPLOAD_TO_S3_NAME: /[&\/\\#, +()$~%'":*?<>{}]/g,
  ADD_SPACE_AFTER_HASHTAG: /(#[^\s#]*)(?![\S])/g,
  ALPHA_NUMERIC_WITHOUT_SPECIAL_CHARS: /^[A-Za-z0-9_]+$/,
  DOMAIN_NAME: /^[a-z0-9]+(-[a-z0-9]+)*(\.[a-z0-9]+(-[a-z0-9]+)*)*\.[a-z]{2,}$/i,
  SUBDOMAIN_NAME: /^[a-z0-9]+(-[a-z0-9]+)*$/i,
  YEAR: /^\d{4}$/,
  HTTP_OR_HTTPS: /^(https?:\/\/)/i,
};

export function postalCodeKeypress(event: KeyboardEvent): boolean {
  return event.key.length !== 1 || /^[A-Za-z0-9 -]$/.test(event.key);
}

export function keyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const input = control.value;
    if (input == null || input === '') return null;
    const allowedChars = new Set([
      ..."!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F",
      "€","‚","ƒ","„","…","†","‡","‰","Š","‹","Œ","Ž","‘","’","“","”","•","–","—","˜","™","š","›","œ","ž","Ÿ",
       "¡","¢","£","¤","¥","¦","§","¨","©","ª","«","¬","®","¯","°","±","²","³","´","µ","¶","·","¸","¹","º","»",
      "¼","½","¾","¿","À","Á","Â","Ã","Ä","Å","Æ","Ç","È","É","Ê","Ë","Ì","Í","Î","Ï","Ð","Ñ","Ò","Ó","Ô","Õ",
      "Ö","×","Ø","Ù","Ú","Û","Ü","Ý","Þ","ß","à","á","â","ã","ä","å","æ","ç","è","é","ê","ë","ì","í","î","ï",
      "ð","ñ","ò","ó","ô","õ","ö","÷","ø","ù","ú","û","ü","ý","þ","ÿ", ' '
    ]);
    const isValid = [...input].every(ch => allowedChars.has(ch));
    return isValid ? null : { notAllowedSpecialChar: true };
  };
}

export function publiclyDisplayedNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const input = control.value;
    if (input == null || input === '') return null;
    return REGEX.PUBLICLY_DISPLAYED_NAME_SPECIAL_CHARS.test(input)
      ? { notAllowedSpecialChar: true }
      : null;
  };
}

const PUBLICLY_DISPLAYED_NAME_NAVIGATION_KEYS = new Set([
  'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight',
  'ArrowUp', 'ArrowDown', 'Delete', 'Enter', 'Escape'
]);

export function publiclyDisplayedNameKeyDown(event: KeyboardEvent): void {
  if (PUBLICLY_DISPLAYED_NAME_NAVIGATION_KEYS.has(event.key)) return;
  if (event.ctrlKey || event.metaKey) return;
  if (event.key.length !== 1) return;
  if (REGEX.PUBLICLY_DISPLAYED_NAME_SPECIAL_CHARS.test(event.key)) {
    event.preventDefault();
  }
}

export function trailingWhitespacesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const input = control.value;
    return input === input.trim() ? null : { trailingWhitespaces: true };
  }
}